<template>
    <div v-if="loaded">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUnidade"
                            :options="form.unidades"
                            @change="loadFrom('unidade')"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableInfraestrutura"
                            :options="form.infraestruturas"
                            @change="loadFrom('infraestrutura')"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableUsuario"
                            :options="form.usuarios"
                            @change="loadFrom('usuario')"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableOcupacao"
                            :options="form.ocupacoes"
                            @change="loadFrom('ocupacao')"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="descricao"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disableEspecialidade"
                            :options="form.especialidades"
                            @change="loadFrom('especialidade')"
                            default-option-text="Todas"
                            label="Especialidade"
                            show-default-option
                            text-field="nome"
                            v-model="model.especialidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-select
                            :disabled="disableProcedimento"
                            :options="form.procedimentos"
                            default-option-text="Todos"
                            label="Procedimentos"
                            show-default-option
                            text-field="descricao"
                            v-model="model.procedimentoCodigo"
                            value-field="codigo"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>

            <rkm-row
                v-for="(item, index) in itens"
                :key="index"
            >
                <rkm-col
                    class="mb-2"
                    cols="12"
                >
                    <rkm-list-group>
                        <rkm-list-group-item class="rkm-list-group-item">
                            <div class="text-center">
                                Unidade: {{ item.unidadeNomeFantasia }}<br>Local de atendimento: {{ item.infraestruturaNome }}
                            </div>
                        </rkm-list-group-item>
                    </rkm-list-group>

                    <rkm-collapse
                        class="rkm-collapse"
                        visible
                    >
                        <rkm-row class="p-2">
                            <rkm-col cols="12">
                                <rkm-table
                                    v-for="(usuario, i) in item.usuarios"
                                    :key="usuario.usuarioId"
                                    :fields="columns"
                                    :class="{ 'mt-2': i > 0 }"
                                    :items="usuario.procedimentos"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template #thead-top>
                                        <rkm-tr>
                                            <rkm-th
                                                :colspan="columns.length"
                                                class="text-center"
                                            >
                                                Profissional: {{ usuario.usuarioNome || '-' }}
                                            </rkm-th>
                                        </rkm-tr>
                                    </template>

                                    <template #cell(ocupacaoCodigo)="{ value }">
                                        {{ value || '-' }}
                                    </template>

                                    <template #cell(especialidadeNome)="{ value }">
                                        {{ value || '-' }}
                                    </template>

                                    <!-- <template #foot(ocupacaoCodigo)>
                                        <span></span>
                                    </template>

                                    <template #foot(especialidadeNome)>
                                        <span></span>
                                    </template>

                                    <template #foot(procedimentoDescricao)>
                                        <span></span>
                                    </template>

                                    <template #foot(quantidade)>
                                        <span>{{ usuario.quantidadeProcedimentos }}</span>
                                    </template> -->
                                    <template #custom-foot>
                                        <rkm-tr>
                                            <rkm-th :colspan="columns.length - 1">
                                                Total de atendimentos: {{ usuario.quantidadeAtendimentos }}
                                            </rkm-th>

                                            <rkm-th class="text-center">
                                                {{ usuario.quantidadeProcedimentos }}
                                            </rkm-th>
                                        </rkm-tr>
                                    </template>
                                </rkm-table>

                                <div class="totalizador d-flex justify-content-around mt-2">
                                    <div>Total de atendimentos do local de atendimento: {{ item.quantidadeAtendimentos }}</div>
                                    <div>Total de procedimentos do local de atendimento: {{ item.quantidadeProcedimentos }}</div>
                                </div>
                            </rkm-col>
                        </rkm-row>
                    </rkm-collapse>
                </rkm-col>
            </rkm-row>

            <div
                v-if="itens.length > 0"
                class="totalizador d-flex justify-content-around"
            >
                <div>Total de atendimentos geral: {{ getSafely(() => totalizadores.quantidadeAtendimentos, 0) }}</div>
                <div>Total de procedimentos geral: {{ getSafely(() => totalizadores.quantidadeProcedimentos, 0) }}</div>
            </div>
        </rkm-area>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, formats, error, data, object, stringCase, file } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                periodo: { required: true },
            }
        },
        disableUnidade() {

            return !this.isPeriodoSelecionado
        },
        disableInfraestrutura() {

            return !this.isPeriodoSelecionado
                || this.model.unidadeId === null
        },
        disableUsuario() {

            return !this.isPeriodoSelecionado
        },
        disableOcupacao() {

            return !this.isPeriodoSelecionado
        },
        disableEspecialidade() {

            return !this.isPeriodoSelecionado
                || this.model.ocupacaoId === null
        },
        disableProcedimento() {

            return !this.isPeriodoSelecionado
        },
        isPeriodoSelecionado() {

            return this.model !== null
                && (this.model.periodo.start instanceof Date)
                && (this.model.periodo.end instanceof Date)
        },
    },
    created() {

        this.repositories = {
            relatorioProcedimentoLancadoPeriodo: this.getConectaSusRepository('ambulatorio.relatorioProcedimentoLancadoPeriodo'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
        }

        this.load()
    },
    data() {

        return {
            loaded: false,
            additionals: null,
            form: null,
            model: null,
            initials: {
                form: null,
                model: null,
            },
            columns: [
                { key: 'ocupacaoCodigo', label: 'CBO', sortable: true },
                { key: 'especialidadeNome', label: 'Especialidade', sortable: true },
                { key: 'procedimentoDescricao', label: 'Procedimento', sortable: true },
                { key: 'quantidade', label: 'Quantidade', class: 'col-min text-center' },
            ],
            itens: [],
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorioProcedimentoLancadoPeriodo.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.initials.form = this.clone(data.form)
                    this.initials.model = this.clone(data.model)

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    if (periodo.start === null || periodo.end === null) {

                        this.resetAfterPeriodo()
                    }
                    else {

                        this.loadFrom('periodo')
                    }
                }
            })
        },
        loadFrom(field) {

            this.clearFrom(field)

            this.setLoading()

            this.repositories.relatorioProcedimentoLancadoPeriodo.list({ ...this.prepareData(), load_from: this.camelToSnake(field) })
                .then(({ data }) => {

                    if ('form' in data) {

                        Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
                    }

                    Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        clearFrom(field) {

            if (field == 'periodo') {

                return
            }

            field = field === 'procedimento' ? `${field}Codigo` : `${field}Id`

            const fields = [
                'unidadeId',
                'infraestruturaId',
                'usuarioId',
                'ocupacaoId',
                'especialidadeId',
                'procedimentoCodigo',
            ]

            fields.slice(fields.indexOf(field) + 1, fields.length)
                .forEach(key => this.$set(this.model, key, null))
        },
        search() {

            this.setLoading()

            this.repositories.relatorioProcedimentoLancadoPeriodo.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data.procedimentos
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {

            this.form = this.clone(this.initials.form)
            this.model = this.clone(this.initials.model)

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        resetAfterPeriodo() {

            this.form = this.clone(this.initials.form)

            const model = this.clone(this.initials.model)

            delete model.periodo

            Object.keys(model).forEach(key => this.$set(this.model, key, model[key]))
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioProcedimentoLancadoPeriodo(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.columns = this.columns.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [repository, formats, error, data, object, stringCase, file],
    watch: {
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
    }
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 400px;
}
.totalizador, .rkm-list-group-item {
    background: #f1f1f1;
    border: 1px solid #dee2e6;
    padding: 0.5rem;
    color: var(--gray-dark);
    font-weight: 600;
}
</style>